<template>
  <div>
    <div class="content has-text-centered has-background-white">
      <img src="../assets/mperaheader.png" height="100px">
    </div>
    <br>
    <div class="container">

      <div class="box">
        <div class="content has-text-centered">
          <h5 class="title is-5">The Montana Public Employee Administration welcomes you to our Defined Benefit Retirement Calculator.</h5>
          <h6 class="title is-6">This calculator allows you to enter your working history to help you plan for your future retirement..</h6>
          <br>
          <h5 class="title is-5">DISCLAIMER</h5>
        </div>
        <p>The benefit estimate you prepare depends on the data you provide. The benefit calculator is not linked to MPERA's database and does not use information contained in your file. <b><i>MPERA is not bound by this estimate.</i></b></p>
        <br>
        <p>All projections are based on statutes, rates and factors currently in effect. Any changes to statutes, rates and factors will change this projection. Do not make decisions based only upon information obtained through this calculator. Contact MPERA for formal estimates if you are serious about retiring.</p>
        <br>
        <p>The benefit calculator has been updated to reflect the new PERS Early Retirement Factors that will be in effect July 1, 2017, and the SRS and HPORS Early Retirement Factors that will be in effect mm/dd/yyyy</p>
        <br>
        <p>I acknowledge and agree that:</p>
        <ul>
        <li>This is merely an ESTIMATE of retirement benefits;</li>
        <li>MPERA and the Public Employees' Retirement Board have no liability or obligation, either legal or equitable, to pay any estimated benefit generated using this benefit calculator;</li>
        <li>This ESTIMATE calculation is not to be construed in any way as a promise or contract between you and MPERA. Your official retirement benefit will be determined by MPERA in accordance with the laws in effect at the time of retirement.</li>
        </ul>

        <br>
        <div class="columns">
          <div class="column">
          </div>
          <div class="column">
          </div>
          <div class="column">
          </div>
          <div class="column">
            <b-field horizontal>
              <button class="button" id="nextButton" v-on:click="gotoHome()">
                <span>I Agree - Continue</span>
                <b-icon icon="arrow-right-bold"></b-icon>
              </button>
            </b-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Disclaimer",
  methods: {
    gotoHome: function(event) {
      this.$router.push('home')
    }
  }
};
</script>
